import React from 'react'
import DriverLayout from '../../layouts/DriverLayout'
import PasswordUpdate from '../../components/PasswordUpdate'

const DriverPassword = () => {
    return (
        <DriverLayout>
            <PasswordUpdate />
        </DriverLayout>
    )
}

export default DriverPassword
